import { render, staticRenderFns } from "./SlicedHeader.vue?vue&type=template&id=92abd9a6&scoped=true"
import script from "./SlicedHeader.vue?vue&type=script&lang=js"
export * from "./SlicedHeader.vue?vue&type=script&lang=js"
import style0 from "./SlicedHeader.vue?vue&type=style&index=0&id=92abd9a6&prod&lang=css"
import style1 from "./SlicedHeader.vue?vue&type=style&index=1&id=92abd9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92abd9a6",
  null
  
)

export default component.exports